import { fetchApi } from "../../config/fetchConfig";

const GET_PROJECT_SCRIPTS_QUERY = `query{projectScripts{name file description}}`;

const RUN_PROJECT_SCRIPT_MUTATION = `mutation($projectId:String!,$file:String!){runProjectScript(projectId:$projectId,file:$file){success executionId message}}`;

const errorResponse = (error) => ({
    data: null,
    errors: [{ message: error?.message || "Api error" }],
});

export const getProjectScriptsAction = () => async (dispatch, getState) => {
    const { user } = getState();
    const queriesBody = {
        query: GET_PROJECT_SCRIPTS_QUERY,
        variables: {},
    };

    try {
        const response = await fetchApi("/graphql", queriesBody, {}, { dispatch, user });
        return response.json();
    } catch (error) {
        return errorResponse(error);
    }
};

export const runProjectScriptAction = (projectId, file) => async (dispatch, getState) => {
    const { user } = getState();
    const queriesBody = {
        query: RUN_PROJECT_SCRIPT_MUTATION,
        variables: { projectId, file },
    };

    try {
        const response = await fetchApi("/graphql", queriesBody, {}, { dispatch, user });
        return response.json();
    } catch (error) {
        return errorResponse(error);
    }
};
